import { render, staticRenderFns } from "./charge-card.vue?vue&type=template&id=f2619572"
import script from "./charge-card.vue?vue&type=script&lang=js"
export * from "./charge-card.vue?vue&type=script&lang=js"
import style0 from "./charge-card.vue?vue&type=style&index=0&id=f2619572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports